import { useState } from 'react';
import {
  ASSIGNEES,
  CATEGORIES,
  CATEGORY_META,
  type Assignee,
  type Category,
  type Priority,
} from '@travel-planner/shared';
import { useCreateItem } from './useListItems';
import { assigneeLabel } from './itemUi';

export function AddItemForm({
  tripId,
  countryId,
  priority,
}: {
  tripId: string;
  countryId: string;
  priority: Priority;
}) {
  const create = useCreateItem(tripId, countryId);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState<Category>('sight');
  const [assignee, setAssignee] = useState<Assignee>('both');

  if (!open) {
    return (
      <button
        className="btn btn-sm w-100 text-body-secondary"
        onClick={() => setOpen(true)}
        style={{ border: '1px dashed var(--border-strong)', background: 'transparent' }}
      >
        + Add
      </button>
    );
  }

  return (
    <form
      className="d-flex flex-column gap-2 p-2 rounded-3"
      style={{ background: 'var(--surface)' }}
      onSubmit={(e) => {
        e.preventDefault();
        if (!title.trim()) return;
        create.mutate(
          { countryId, priority, category, assignee, title: title.trim() },
          {
            onSuccess: () => {
              setTitle('');
              setCategory('sight');
              setAssignee('both');
            },
          },
        );
      }}
    >
      <input
        className="form-control form-control-sm"
        autoFocus
        placeholder="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <div className="d-flex gap-2">
        <select
          className="form-select form-select-sm"
          style={{ flex: 1 }}
          value={category}
          onChange={(e) => setCategory(e.target.value as Category)}
        >
          {CATEGORIES.map((c) => (
            <option key={c} value={c}>
              {CATEGORY_META[c].icon} {CATEGORY_META[c].label}
            </option>
          ))}
        </select>
        <select
          className="form-select form-select-sm"
          style={{ width: 'auto' }}
          value={assignee}
          onChange={(e) => setAssignee(e.target.value as Assignee)}
        >
          {ASSIGNEES.map((a) => (
            <option key={a} value={a}>
              {assigneeLabel(a)}
            </option>
          ))}
        </select>
      </div>
      <div className="d-flex gap-2">
        <button type="submit" className="btn btn-primary btn-sm" disabled={!title.trim() || create.isPending}>
          {create.isPending ? 'Adding…' : 'Add'}
        </button>
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => setOpen(false)}>
          Close
        </button>
      </div>
    </form>
  );
}
